var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.17,
    height: 177.17,
    shapeRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 0,
    x1: 21.376,
    x2: 77.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1a17",
    d: "m28.408 9.22h4.216v-3.395h6.796v9.295l-5.5 4.243v11.857l4.22 4.221v5.08h3.789v5.929h-33.859v-5.929h3.794v-5.08l4.246-4.221v-11.857l-5.508-4.243v-9.295h6.774v3.395h4.242v-3.395h6.79z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0)",
    d: "m33.07 17.678l3.15-2.557h-22.42l3.175 2.557h16.1m7.197 24.528h-30.514v2.557h30.514v-2.557m-3.844-5.05h-22.826v3.37h22.826v-3.37m-4.216-17.788h-14.393v11.862h14.393v-11.862m5.503-5.927v-5.927h-3.395v3.395h-7.645v-3.395h-3.344v3.395h-7.62v-3.395h-3.395v5.927h25.4m-1.913 22l-2.548-2.532h-16.451l-2.599 2.532h21.598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWR);
export default __webpack_public_path__ + "static/media/wR.a5a16b367926231b6079ae531371b789.svg";
export { ForwardRef as ReactComponent };